import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Label } from 'semantic-ui-react';

const TabDate = ({ value, count }: { value: string; count: number }): JSX.Element => {
  const { t } = useTranslation();
  const date = moment(value, 'YYYY-MM-DD');
  const line1 = t('program.tabs.line1', { date });
  const line2 = t('program.tabs.line2', { date });
  return (
    <div className="tab--date">
      {!!line1 && (
        <div className="tab--date--1">
          {line1}{' '}
          <Label size="tiny" className="count" circular color={count > 0 ? 'blue' : 'grey'}>
            {count}
          </Label>
        </div>
      )}
      {!!line2 && <div className="tab--date--2">{line2}</div>}
    </div>
  );
};

export default TabDate;
